import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Web3Provider } from './contexts/Web3Context';
import { Toaster } from './components/ui/sonner';
import { Landing } from './pages/Landing';
import { MSMEDashboard } from './pages/MSMEDashboard';
import { Marketplace } from './pages/Marketplace';
import { InvoiceDetails } from './pages/InvoiceDetails';
import './App.css';

function App() {
  return (
    <Web3Provider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/msme" element={<MSMEDashboard />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/invoice/:id" element={<InvoiceDetails />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </Web3Provider>
  );
}

export default App;